<template>
    <v-container class="fully-centered">
        <v-row>
            <v-col>
                <v-alert prominent dark color="red darken-2" :type="type" border="top">
                    <v-row>
                        <v-col class="text-center">
                            <h2>{{ title }}</h2>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="text-center">
                            <p>
                                {{content}}
                            </p>
                        </v-col>
                    </v-row>
                </v-alert>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ContextualMixin from '../mixins/contextualMixin'
    export default {
        name: 'Error',
        mixins: [ContextualMixin],
        props: ['title', 'content', 'type']
    }
</script>